// This file contains the standard national immunization schedule.
// Data is based on IDAI (Ikatan Dokter Anak Indonesia) recommendations.

export const immunizationSchedule = [
    { age: 0, name: "Hepatitis B (HB-0)", description: "Diberikan dalam 24 jam pertama setelah lahir." },
    { age: 1, name: "Polio 0", description: "Diberikan saat bayi baru lahir atau sebelum pulang dari fasilitas kesehatan." },
    { age: 1, name: "BCG", description: "Diberikan sebelum bayi berusia 1 bulan untuk mencegah TBC berat." },
    { age: 2, name: "DTP-HB-Hib 1", description: "Mencegah Difteri, Tetanus, Pertusis, Hepatitis B, dan Haemophilus influenzae tipe b." },
    { age: 2, name: "Polio 1", description: "Vaksin polio tetes atau suntik dosis pertama." },
    { age: 2, name: "Rotavirus 1", description: "Mencegah diare berat akibat rotavirus." },
    { age: 2, name: "PCV 1", description: "Mencegah infeksi paru (pneumonia) akibat bakteri pneumokokus." },
    { age: 3, name: "DTP-HB-Hib 2", description: "Dosis kedua vaksin DTP-HB-Hib." },
    { age: 3, name: "Polio 2", description: "Dosis kedua vaksin polio." },
    { age: 4, name: "DTP-HB-Hib 3", description: "Dosis ketiga vaksin DTP-HB-Hib." },
    { age: 4, name: "Polio 3", description: "Dosis ketiga vaksin polio." },
    { age: 4, name: "Rotavirus 2", description: "Dosis kedua vaksin Rotavirus (tergantung jenis vaksin)." },
    { age: 4, name: "PCV 2", description: "Dosis kedua vaksin PCV." },
    { age: 9, name: "Campak Rubella (MR)", description: "Mencegah penyakit Campak dan Rubella." },
    { age: 12, name: "PCV 3", description: "Dosis ketiga (booster) vaksin PCV." },
    { age: 18, name: "DTP-HB-Hib 4 (Booster)", description: "Dosis penguat (booster) pertama." },
    { age: 18, name: "Polio 4 (Booster)", description: "Dosis penguat (booster) pertama." },
    { age: 18, name: "Campak Rubella (MR) 2 (Booster)", description: "Dosis penguat (booster) untuk Campak dan Rubella." },
];
